import React, { Component } from 'react';
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import Atendimento from '../componentes/Atendimento';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';
import FloatingWhatsApp from '../componentes/WhatsAppFlutuante';
import { fetchRevenda, subscribeToCollection } from '../utils/firestoreUtils';
import { scrollToTop } from '../utils/scrollUtils';
import { sendSellEmail } from '../utils/emailUtils';

class VendaSeuVeiculo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nome: '',
            email: '',
            telefone: '',
            marca: '',
            modelo: '',
            versao: '',
            cor: '',
            km: '',
            placa: '',
            ano_modelo: '',
            opcionais: '',
            enviado: false,
            msg_enviado: '',
            revenda: {},
        }
        this.mounted = false;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount() {
        scrollToTop();

        this.unsubscribeFunctions = [];

        fetchRevenda(this.setState.bind(this));

        subscribeToCollection(
            "veiculos",
            {
                filters: [
                    ["veremovido", "==", 0],
                    ["vevendido", "==", 0]
                ],
                orderBy: "updated_at",
                stateKey: "veiculos",
                processDoc: (document) => (document["veexibir_site"] !== false ? document : null),
            },
            (state) => {
                this.setState({
                    veiculos: state.veiculos,
                    veiculosComplete: state.veiculos
                });
            },
            this.unsubscribeFunctions
        );
    }

    handleChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
    
        sendSellEmail(this.state, this.setState.bind(this));
    };

    render() {
        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />
                {/*<FloatingWhatsApp />*/}

                <section>
                    <div className="container">
                        <div className="row text-center intro-title">
                            <div className="col-md-12 text-md-left d-inline-block">
                                <h1 className="text-black">VENDA SEU CARRO</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <div>
                    <section className="b-contacts s-shadow">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-6">
                                    <div className="b-contacts__form ">
                                        <header className="b-contacts__form-header s-lineDownLeft wow zoomInUp" data-wow-delay="0.5s">
                                            <h2 className="s-titleDet">Solicite uma avaliação do seu carro</h2>
                                        </header>
                                        <p className=" wow zoomInUp" data-wow-delay="0.5s">Envie para nossa equipe os dados do seu carro para fazermos uma proposta. Em breve retornaremos o contato.</p>
                                        <ValidatorForm id="contactForm" className="s-form wow zoomInUp" ref="form" onSubmit={this.handleSubmit} >
                                            <TextValidator
                                                label="NOME *"
                                                onChange={this.handleChange}
                                                name="nome"
                                                value={this.state.nome}
                                                className="form-ui-bootstrap"
                                                validators={['required']}
                                                errorMessages={['Preenchimento obrigatório']}
                                            />
                                            <TextValidator
                                                label="E-MAIL *"
                                                onChange={this.handleChange}
                                                name="email"
                                                value={this.state.email}
                                                className="form-ui-bootstrap"
                                                validators={['required', 'isEmail']}
                                                errorMessages={['Preenchimento obrigatório', 'E-mail inválido']}
                                            />
                                            <InputMask
                                                mask="(99) 99999-9999"
                                                value={this.state.telefone}
                                                label="TELEFONE *"
                                                name="telefone"
                                                onChange={this.handleChange}
                                            >
                                                {() => <TextField
                                                    label="TELEFONE *"
                                                    name="telefone"
                                                    type="text"
                                                    className="form-ui-bootstrap"
                                                />}
                                            </InputMask>
                                            <TextValidator
                                                label="MARCA *"
                                                onChange={this.handleChange}
                                                name="marca"
                                                value={this.state.marca}
                                                className="form-ui-bootstrap"
                                                validators={['required']}
                                                errorMessages={['Preenchimento obrigatório']}
                                            />
                                            <TextValidator
                                                label="MODELO *"
                                                onChange={this.handleChange}
                                                name="modelo"
                                                value={this.state.modelo}
                                                className="form-ui-bootstrap"
                                                validators={['required']}
                                                errorMessages={['Preenchimento obrigatório']}
                                            />
                                            <TextValidator
                                                label="VERSÃO"
                                                onChange={this.handleChange}
                                                name="versao"
                                                value={this.state.versao}
                                                className="form-ui-bootstrap"
                                            />
                                            <TextValidator
                                                label="COR"
                                                onChange={this.handleChange}
                                                name="cor"
                                                value={this.state.cor}
                                                className="form-ui-bootstrap"
                                            />
                                            <TextValidator
                                                label="KM *"
                                                onChange={this.handleChange}
                                                name="km"
                                                value={this.state.km}
                                                className="form-ui-bootstrap"
                                                validators={['required']}
                                                errorMessages={['Preenchimento obrigatório']}
                                            />
                                            <TextValidator
                                                label="PLACA"
                                                onChange={this.handleChange}
                                                name="placa"
                                                value={this.state.placa}
                                                className="form-ui-bootstrap"
                                            />
                                            <TextValidator
                                                label="ANO/MODELO *"
                                                onChange={this.handleChange}
                                                name="ano_modelo"
                                                value={this.state.ano_modelo}
                                                className="form-ui-bootstrap"
                                                validators={['required']}
                                                errorMessages={['Preenchimento obrigatório']}
                                            />
                                            <TextValidator
                                                label="OPCIONAIS"
                                                onChange={this.handleChange}
                                                name="opcionais"
                                                value={this.state.opcionais}
                                                className="form-ui-bootstrap"
                                            />
                                            <button type="submit" className="btn m-btn">ENVIAR DADOS<span className="fa fa-angle-right"></span></button>
                                            {
                                                this.state.enviado &&
                                                <blockquote>
                                                    <p><em>{this.state.msg_enviado}</em></p>
                                                </blockquote>
                                            }
                                        </ValidatorForm>
                                    </div>
                                </div>
                                <Atendimento revenda={this.state.revenda} />
                            </div>
                        </div>
                    </section>
                </div>
                <Rodape revenda={this.state.revenda} />
            </div>
        )
    }
}

export default VendaSeuVeiculo;